import { render } from "./Block.vue?vue&type=template&id=7c6020ba&scoped=true&ts=true"
import script from "./Block.vue?vue&type=script&lang=ts"
export * from "./Block.vue?vue&type=script&lang=ts"

import "./Block.vue?vue&type=style&index=0&id=7c6020ba&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6020ba"]])

export default __exports__